import { useState } from "react";
import SecondarySidebar from "../../components/SideBar/SecondarySidebar";
import { FaUser, FaBuilding, FaCalculator, FaCog } from "react-icons/fa";
import { RiImportFill } from "react-icons/ri";
import HeaderCard from "../../components/Header/HeaderCard";
import User from "./Tabs/User";
import Company from "./Tabs/Company";
import Security from "./Tabs/Security";
import Import from "./Tabs/Import";
import Accounting from "./Tabs/Accounting";
import Modal from "../../components/Utils/ModalShow";
import ActionDropdown from "../../components/Utils/ActionDropdown";
import {notify} from "../../components/Utils/Notifications";
import { apiService } from "../../components/Config/api.service";

// { id: "securite", label: "Sécurité", icon: <FaLock />, description: "Mot de passe et sécurité" },
const menuItems = [
  { id: "societe", label: "Société", icon: <FaBuilding />, description: "Informations de l'entreprise" },
  { id: "utilisateur", label: "Utilisateur", icon: <FaUser />, description: "Profil utilisateur" },
  { id: "comptabilite", label: "Comptabilité", icon: <FaCalculator />, description: "Codes comptables et paramètres" },
  { id: "import_export", label: "Import/Export", icon: <RiImportFill />, description: "Gestion des données" },
];

const Settings = () => {
  const [activeTab, setActiveTab] = useState("societe");
  const [showAddSocietyModal, setShowAddSocietyModal] = useState(false);
  const [newSociety, setNewSociety] = useState({ name: "", address: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [companyCreated, setCompanyCreated] = useState(null); // {id, name}

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  console.log(user);
  const multicompany = user.multicompany;

  const getTabTitle = () => {
    const tab = menuItems.find(item => item.id === activeTab);
    return tab ? tab.label : "Paramètres";
  };

  const getTabDescription = () => {
    const tab = menuItems.find(item => item.id === activeTab);
    return tab ? tab.description : "";
  };

  

  const handleAddSociety = async () => {
    setIsLoading(true);
    try {
      const payload = {
        name: newSociety.name,
        address: newSociety.address,
      };
      const response = await apiService.saveElement("/company/create", payload);
      if (response.data.success) {
        notify("Nouvelle société créée avec succès", false, 2);
        setCompanyCreated({
          id: response.data.company_id,
          name: newSociety.name
        });
      } else {
        notify("Erreur lors de la création de la société", false, 3);
        setCompanyCreated(null);
      }
    } catch (error) {
      notify("Erreur lors de la création de la société", false, 3);
      setCompanyCreated(null);
    }
    setIsLoading(false);
    setNewSociety({ name: "", address: "" });
  };

  const handleMigrate = async () => {
    if (!companyCreated?.id) return;
    setIsLoading(true);
    try {
      const switchResponse = await apiService.saveElement(`/switch_company/${companyCreated.id}`, {});
      if (switchResponse.data.active_company_name) {
        localStorage.setItem('companyName', switchResponse.data.active_company_name);
        window.location.reload();
      }
    } catch (error) {
      notify("Erreur lors de la migration vers la société", false, 3);
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowAddSocietyModal(false);
    setCompanyCreated(null);
    setIsLoading(false);
    setNewSociety({ name: "", address: "" });
  };

  return (
  <>
    <div className="space-y-6">
      <HeaderCard 
        title="Paramètres" 
        text="Configurez votre application selon vos besoins et préférences."
      />

      <div className="flex gap-6">
        {/* Sidebar */}
        <div className="w-80 flex-shrink-0 self-start sticky top-6">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="px-6 py-4 border-b border-gray-200">
              <div className="flex items-center gap-3">                
                <h3 className="text-lg font-semibold text-gray-800">Configuration</h3>
              </div>
              <p className="text-sm text-gray-600 mt-1">Gérez les paramètres de votre application</p>
            </div>
            <div className="p-2">
              <SecondarySidebar
                menuItems={menuItems}
                setActiveTab={setActiveTab}
                activeTab={activeTab}
              />
            </div>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 min-w-0">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="px-6 py-4 border-b border-gray-200">
              <div className="flex items-center gap-3">
                <div className="bg-blue-100 rounded-full p-2">
                  {menuItems.find(item => item.id === activeTab)?.icon}
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-800">{getTabTitle()}</h3>
                  <p className="text-sm text-gray-600">{getTabDescription()}</p>
                </div>
                {activeTab === "societe" && multicompany && (
                  <ActionDropdown
                    actions={[
                      {
                        label: "Ajouter une société",
                        icon: <FaBuilding />,
                        onClick: () => setShowAddSocietyModal(true),
                      },
                      // {
                      //   label: "Gérer mes sociétés",
                      //   icon: <FaCog />,
                      //   onClick: () => console.log("Gérer mes sociétés")
                      // }
                    ]}
                  />
                )}
              </div>
            </div>
            <div className="p-6">
              {activeTab === "societe" && <Company />}
              {activeTab === "utilisateur" && <User />}
              {activeTab === "comptabilite" && <Accounting />}
              {activeTab === "securite" && <Security />}
              {activeTab === "import_export" && <Import />}
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Modal for adding society - Example implementation */}
      <Modal
        isOpen={showAddSocietyModal}
        onClose={handleCloseModal}
        title="Ajouter une société"
        headerIcon={<FaBuilding />}
        footer={
          companyCreated ? (
            <>
              <button
                className="px-4 py-2 rounded bg-gray-200 text-gray-700 mr-2"
                onClick={handleCloseModal}
                type="button"
                disabled={isLoading}
              >
                Fermer
              </button>
              <button
                className="px-4 py-2 rounded bg-[--color-primary] text-white"
                onClick={handleMigrate}
                type="button"
                disabled={isLoading}
              >
                {isLoading ? "Migration..." : "Migrer vers la société"}
              </button>
            </>
          ) : (
            <>
              <button
                className="px-4 py-2 rounded bg-gray-200 text-gray-700 mr-2"
                onClick={handleCloseModal}
                type="button"
                disabled={isLoading}
              >
                Annuler
              </button>
              <button
                className="px-4 py-2 rounded bg-[--color-primary] text-white"
                onClick={handleAddSociety}
                type="button"
                disabled={isLoading}
              >
                {isLoading ? "Création..." : "Créer"}
              </button>
            </>
          )
        }
      >
        {isLoading && !companyCreated && (
          <div className="text-center py-6">
            <span className="animate-spin inline-block mr-2">&#9696;</span>
            Création de la société en cours...
          </div>
        )}
        {!isLoading && !companyCreated && (
          <form
            onSubmit={e => {
              e.preventDefault();
              handleAddSociety();
            }}
          >
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Nom de la société</label>
              <input
                type="text"
                className="w-full border rounded px-3 py-2"
                value={newSociety.name}
                onChange={e => setNewSociety({ ...newSociety, name: e.target.value })}
                required
                disabled={isLoading}
              />
            </div>
            <div className="mb-2">
              <label className="block text-sm font-medium mb-1">Adresse</label>
              <input
                type="text"
                className="w-full border rounded px-3 py-2"
                value={newSociety.address}
                onChange={e => setNewSociety({ ...newSociety, address: e.target.value })}
                disabled={isLoading}
              />
            </div>
          </form>
        )}
        {companyCreated && (
          <div className="text-center py-6">
            <div className="text-[--color-primary] font-bold mb-2">
              La société <span className="underline">{companyCreated.name}</span> a été créée avec succès !
            </div>
            <div className="mb-4">Souhaitez-vous switcher vers la société créée ?</div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default Settings;